import React from "react";
import styles from "./BackButton.module.css";
import { useNavigate } from "react-router-dom";
import CtaBtns from "../CtaBtns/CtaBtns.module";
const BackButton = () => {
  const navigate = useNavigate();
  const goMain = () => {
    navigate("/");
  };

  return (
    <div className={styles.items}>
      {/* <div className={styles.goBack} onClick={() => goMain()}>
        بازگشت
        <i className="fas fa-chevron-left"></i>
      </div> */}
      <div className={styles.backButton}>
        <CtaBtns
          icon="fas fa-chevron-left"
          iconWhere="left"
          onAtion={() => goMain()}
          onClick={() => goMain()}
        >
          بازگشت
        </CtaBtns>
      </div>
    </div>
  );
};

export default BackButton;
